import { LegalLayout } from "../components/LegalLayout";
import { ABOUT_PAGE } from "../data/legalPages";
import { COMPANY } from "../data/company";

const FounderPhoto = () => (
  <figure className="flex flex-col sm:flex-row items-center gap-6 p-6 rounded-3xl border border-black/5 bg-white/60 mb-12" data-testid="about-founder-card">
    {COMPANY.founderPhoto ? (
      <img src={COMPANY.founderPhoto} alt={COMPANY.founderPhotoAlt} className="w-32 h-32 rounded-2xl object-cover shrink-0" data-testid="about-founder-photo" />
    ) : (
      <div
        role="img"
        aria-label={COMPANY.founderPhotoAlt}
        title={COMPANY.founderPhotoAlt}
        className="w-32 h-32 rounded-2xl bg-[#1A3B2B] text-[#FDFBF7] font-display text-4xl flex items-center justify-center shrink-0"
        data-testid="about-founder-photo"
      >
        GS
      </div>
    )}
    <figcaption className="text-center sm:text-left">
      <p className="font-display text-2xl">{COMPANY.operator}</p>
      <p className="text-sm text-muted-foreground">{COMPANY.operatorRole} · {COMPANY.location}</p>
      <p className="text-sm text-muted-foreground mt-1">ABN {COMPANY.abn}</p>
    </figcaption>
  </figure>
);

export default function About() {
  return <LegalLayout page={ABOUT_PAGE} testId="about-page" showUpdated={false} before={<FounderPhoto />} />;
}
